import React from "react";

export function StubTabBody({
  summary,
  children,
}: {
  summary: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <div>
      <div
        style={{
          padding: "8px 10px",
          background: "#0a0a12",
          borderBottom: "1px solid #1c1c26",
          color: "#cfd2dc",
          fontSize: 11,
          lineHeight: 1.5,
        }}
      >
        {summary}
      </div>
      {children}
    </div>
  );
}

export function StubTabRow({
  label,
  hint,
}: {
  label: string;
  hint: string;
}): JSX.Element {
  return (
    <div
      style={{
        padding: "8px 10px",
        background: "#0e0e15",
        borderBottom: "1px solid #1c1c26",
        color: "#7a8098",
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 600, color: "#9aa0b4" }}>{label}</div>
      <div style={{ fontSize: 11, marginTop: 2 }}>{hint}</div>
    </div>
  );
}
